import { ShareStatus } from "@authory-packages/core";
import { getServerSidePropsForProfile, V4ProfilePublicPageLayoutContainer } from "../../../pagelayouts/profile/V4ProfilePublicPageLayoutContainer";
import { ProfileAccessGate } from "../../../pages-components/ProfileAccessGate/ProfileAccessGate";

const PortfolioPublicPage = ({ profileShareStatus }: { profileShareStatus: ShareStatus }) => {
    return (
        <ProfileAccessGate profileShareStatus={profileShareStatus}>
            <V4ProfilePublicPageLayoutContainer profileShareStatus={profileShareStatus} />
        </ProfileAccessGate>
    );
};

export default PortfolioPublicPage;

export const getServerSideProps = getServerSidePropsForProfile(false);
